import { render, staticRenderFns } from "./VideoBanner.vue?vue&type=template&id=2668b01e&scoped=true&"
import script from "./VideoBanner.vue?vue&type=script&lang=ts&"
export * from "./VideoBanner.vue?vue&type=script&lang=ts&"
import style0 from "./VideoBanner.vue?vue&type=style&index=0&id=2668b01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668b01e",
  null
  
)

export default component.exports